module.exports = __webpack_public_path__ + "img/icwithdraw.e1b242c1.png";